import{gql as o}from"@apollo/client";import{GELADA_PROJECT_FRAGMENT as e}from"../../graphql/fragments/geladaProject.fragment.js";const a=o`
  query getGeladaProjectByDomain(
    $domain: String!
    $shouldIncludeProjectDomain: Boolean = false
    $shouldIncludeProjectLogo: Boolean = false
    $shouldIncludeProjectSettings: Boolean = false
    $shouldIncludeProjectTheme: Boolean = false
  ) {
    getGeladaProjectByDomain: getByDomain(domain: $domain) {
      ...geladaProjectFragment
    }
  }

  ${e}
`;export{a as GET_GELADA_PROJECT_BY_DOMAIN_QUERY};
//# sourceMappingURL=useGetGeladaProjectByDomain.graphql.js.map
